import React from 'react';
import ActionCardFooterElement from './ActionCardFooterElement';
function ActionCardFooter(_a) {
    var actions = _a.actions;
    return (React.createElement("div", { className: "elmo-actioncard__footer" },
        React.createElement(ActionCardFooterElement, { position: 'left', actions: actions.filter(function (action) { return action.position === 'left'; }) }),
        React.createElement(ActionCardFooterElement, { position: 'right', actions: actions.filter(function (action) { return action.position !== 'left'; }) })));
}
export default ActionCardFooter;
